import React, {useEffect, useState} from 'react'

import {ProfileCard} from './profile-card'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import PencilIcon from '@mui/icons-material/Edit'
import AddIcon from '@mui/icons-material/Add'
import Fade from '@mui/material/Fade/Fade'
import diverCertifications from '../../diver-certifications.json'
import CircularProgress from '@mui/material/CircularProgress/CircularProgress'
import Fab from '@mui/material/Fab'
import {useTranslation} from "next-i18next"
import {useDispatch, useSelector} from "../../store";
import {Box, IconButton} from "@mui/material";
import {DiverCertification} from "seacrush-core"
import {CertificationDetailsDialog} from "./certification-details-dialog";
import {deepCopy} from "../../utils/deep-copy";
import {updateCertifications} from "../../slices/user-session-slice";


export interface MutableDiverCertification extends DiverCertification {
    index: number
    submitAction: "delete" | "save" | "cancel" | null
}

export const CertificationsCard = () => {

    const {t, i18n} = useTranslation()

    const dispatch = useDispatch()

    const {
        isUpdatingProfile,
        currentProfile: {certBody, certLevel, certifications}
    } = useSelector((state) => state.userSession);

    const [editCertItem, setEditCertItem] = useState<MutableDiverCertification | null>(null)


    const [submitting, setSubmitting] = useState(false)

    const [editing, setEditing] = useState(false)


    const handleEditChange = (newEditing: boolean) => {
        setEditing(newEditing);
    };

    useEffect(() => {

        if (!isUpdatingProfile && editCertItem) {
            setEditCertItem(null)
        }

    }, [isUpdatingProfile])


    const handleSave = async () => {

        setSubmitting(true)

        // const certSnapshot = await db.collection(`users/${uid}/certifications`).get()
        //
        // const batch = db.batch()
        //
        // for (const doc of certSnapshot.docs) {
        //     batch.delete(doc.ref)
        // }
        //
        // let idx = 0
        // for (const cert of certificationArray) {
        //     batch.set(db.doc(`users/${uid}/certifications/${idx}`), cert)
        //     idx++
        // }
        //
        // if (certificationArray.length > 0) {
        //     batch.set(db.doc(`users/${uid}`), {
        //             certBody: certificationArray[0].certBody,
        //             certLevel: certificationArray[0].certLevel
        //         },
        //         {merge: true})
        // }
        //
        // batch.commit().then(() => {
        //     setSubmitting(false)
        //     dispatch(fetchUserProfile(uid))
        // }).catch((error) => {
        //     setSubmitting(false)
        //     console.error('Error setting document: ', error)
        // })

    }

    const addCertificationClicked = () => {
        const newCert: MutableDiverCertification = {
            certBody: '',
            certLevel: '',
            certLocation: '',
            index: -1,
            submitAction: null
        }
        setEditCertItem(newCert)
    }


    const handleEditFinished = (mutableCert: MutableDiverCertification) => {

        const newCerts = deepCopy(certifications)

        switch (mutableCert.submitAction) {
            case "delete":
                newCerts.splice(mutableCert.index, 1)
                dispatch(updateCertifications(newCerts))
                return;
            case "save":
                if (mutableCert.index >= 0) {
                    const idx = mutableCert.index
                    newCerts[idx] = mutableCert as DiverCertification
                } else {
                    newCerts.unshift(mutableCert as DiverCertification)
                }

                newCerts.sort((a: DiverCertification, b: DiverCertification) => {
                    if (!a.certBody || !a.certBody || !b.certBody || !b.certLevel) return 0
                    return diverCertifications[b.certBody as keyof typeof diverCertifications].indexOf(b.certLevel) - diverCertifications[a.certBody as keyof typeof diverCertifications].indexOf(a.certLevel)
                })
                dispatch(updateCertifications(newCerts))
                return;
            case "cancel":
            default:
                setEditCertItem(null)
        }

    }

    return <ProfileCard title={t('certifications')}
                        editing={editing}
                        onEditingChanged={handleEditChange}>


        <Box sx={editing ? {
            maxWidth: 500,
            backgroundColor: '#fff',
            borderRadius: 1,
            border: '1px solid rgba(0, 0, 0, 0.23)'
        } : {
            maxWidth: 500
        }
        }>
            <List>

                {certifications.map((cert: DiverCertification, idx: number) => {

                    return <ListItem key={idx}

                                     secondaryAction={
                                         <Fade in={editing}>
                                             <IconButton edge={"end"} aria-label={"edit"}
                                                         onClick={e => {
                                                             editing && setEditCertItem({...cert, index: idx, submitAction: null})
                                                         }}
                                             >
                                                 <PencilIcon/>
                                             </IconButton>
                                         </Fade>
                                     }
                    >
                        <ListItemText
                            primary={`${cert.certBody} ${cert.certLevel}`}
                            secondary={cert.certLocation}
                        />
                    </ListItem>

                })}
            </List>
            {editing &&
                <Fade in={editing} style={{margin: '0 auto', marginBottom: 16, paddingTop: 4, display: 'block'}}>

                    <Fab variant="extended" color="primary" aria-label="Add"

                         onClick={addCertificationClicked}>
                        <AddIcon sx={{mr: 1, verticalAlign: "middle"}}/> {t('add-certification')}
                    </Fab>

                </Fade>
            }
        </Box>

        {submitting && <CircularProgress size={24} sx={{m: 2}}/>}


        {editCertItem && <CertificationDetailsDialog cert={editCertItem} onEditFinished={handleEditFinished}/>}

    </ProfileCard>
}
